import { t } from "i18next";
import { emptyTopicPart } from "../entities/TopicPart";
import { topicPartRepository } from "../../../providers/repositories/topicPartRepository";
import { topicPartQuestionRepository } from "../../../providers/repositories/topicPartQuestionRepository";
import { toast } from "react-toastify";
import Logger from "../../../utils/Logger";

export const createSynthesisPartUseCase = {
    async exec(topicId: string | undefined): Promise<string | null> {
        if (!topicId) return null;

        try {
            const existingParts = await topicPartRepository.getAll(topicId);
            const hasSynthesisPart = existingParts.some(
                (part) => part.isSynthesisPart,
            );

            if (hasSynthesisPart) {
                toast.error(t("topicPart.synthesisPartAlreadyExists"), { autoClose: 3000 });
                return null;
            }

            const topicPart = await topicPartRepository.addUpdate(
                {
                    ...emptyTopicPart(topicId),
                    title: t("topicPart.defaultSynthesis.title"),
                    description: t("topicPart.defaultSynthesis.description"),
                    contentText: t("topicPart.defaultSynthesis.text"),
                    answerTogether: true,
                    isSynthesisPart: true,
                },
                null,
            );

            const questions = [
                t("topicPart.defaultSynthesis.question1"),
                t("topicPart.defaultSynthesis.question2"),
            ];

            for (const text of questions) {
                await topicPartQuestionRepository.addUpdate(
                    {
                        topicPartId: topicPart.id,
                        text,
                        answerType: "text",
                        answers: [],
                        comments: "",
                    },
                    null,
                );
            }

            return topicPart.id;
        } catch (error) {
            Logger.error("createSynthesisPartUseCase", error);
            toast.error(t("action.updateError"));
            return null;
        }
    },
};
